"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _constants = require("../Icon/constants");

var _constants2 = require("./constants");

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AntStep = _antd.Steps.Step;
var iconTypesMap = new Map([[_constants2.STEP_STATUS_FINISH, _constants.ICON_TYPE_VERIFIED], [_constants2.STEP_STATUS_PROCESS, _constants.ICON_TYPE_RADIO]]);

function Step(props) {
  var icon = /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: iconTypesMap.get(props.status)
  });

  return /*#__PURE__*/_react.default.createElement(AntStep, _extends({
    icon: icon
  }, props));
}

Step.propTypes = {
  /** The status of current step */
  status: _propTypes.default.oneOf(_constants2.STEP_STATUS_TYPES),

  /** Title shown below the step icon */
  title: _propTypes.default.string
};
Step.defaultProps = {
  status: null,
  title: null
};
var _default = Step;
exports.default = _default;